var React = require('react');

function BackArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"d":"M0,15.89v-5.6L34.2,0V4.1L12.53,13.16,34.2,22.08v4.17Z","key":0}),React.createElement("path",{"d":"M11.93,15.8V10.46H68.07V15.8Z","key":1})])));
}

BackArrow.defaultProps = {"viewBox":"0 0 68.07 26.25"};

module.exports = BackArrow;

BackArrow.default = BackArrow;
